exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button .zb-spin[data-v-952c743a]{display:none}button.loading .zb-spin[data-v-952c743a]{display:inline-block}.standard-list ul li[data-v-952c743a]:before{color:#000}", ""]);

// exports
